import React from 'react'
import { BtnV2, l } from '@ds/index'
import cx from 'classnames'

import { DefaultPlansView } from '../Paywall/variants/UniversalPaywall/steps/Plan'

import { AllPlansView } from './AllPlansView/AllPlansView'
import { PriceDownPlansView } from './PriceDownPlansView'
import { PriceUpPlansView } from './PriceUpPlansView'
import { useMigrationPlansView } from './useMigrationPlansView'
import { getHeaderAndSubheader } from './utils'

import cm from './MigrationPlansView.module.css'

enum Steps {
  ALL_PLANS = 'allPlans',
  RECOMMENDED_PLAN = 'recommendedPlan',
}

export const ProMigrationPlansView = () => {
  const [currentStep, setCurrentStep] = React.useState<Steps>(Steps.RECOMMENDED_PLAN)
  const migrationViewData = useMigrationPlansView()

  if (!migrationViewData.isReady) {
    return <DefaultPlansView />
  }

  const {
    isPriceDown,
    targetData: { slug },
    registerConsent,
  } = migrationViewData

  const content = () => {
    if (isPriceDown) {
      return <PriceDownPlansView migrationViewData={migrationViewData} />
    } else {
      return <PriceUpPlansView migrationViewData={migrationViewData} />
    }
  }

  const contentElement = content()

  if (currentStep === Steps.ALL_PLANS) {
    return <AllPlansView registerConsent={registerConsent} targetSlug={slug} />
  }

  const { header, subheader } = getHeaderAndSubheader({
    isPriceDown,
  })

  return (
    <div className={cm.root}>
      <div className={cm.headers}>
        {header && <h1 className={cx('text-heading', cm.title)}>{l.getString(header)}</h1>}
        {subheader && (
          <p className={cx('text-body-lg m-t-xxs', cm.description)}>{l.getString(subheader)}</p>
        )}
      </div>
      <div className={cx(cm.contentRoot, { [cm.contentRootNarrow]: isPriceDown })}>
        {contentElement}
      </div>
      <footer className="text-body-sm m-t text-center">
        <BtnV2
          onClick={() => setCurrentStep(Steps.ALL_PLANS)}
          size="small"
          className="d-inline-flex"
          capitalize={false}
        >
          {l.translate('See other plans')}
        </BtnV2>
      </footer>
    </div>
  )
}
